import React from 'react';

function RecycleBin({ stroke = '#1D1C1D', width = 16, height = 16, style }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} width={width} height={height} viewBox="0 2 24 24" fill="stroke">
      <path fill="none" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7h16m-10 4v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"></path>
    </svg>
  );
}

export default RecycleBin;
